import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes/index.js'

import store from '@/store/index.js'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        // if (savedPosition) {
        //   return savedPosition // 按下 后退/前进 按钮时，类似浏览器的原生表现
        // } else {
        //   return {
        //     x: 0,
        //     y: 0
        //   } // 让页面滚动到顶部
        // }
        return {
            x: 0,
            y: 0
        } // 让页面滚动到顶部
    }
})
// 为路由对象添加 beforeEach,导航守卫
// router.beforeEach((to, form, next) => {
//     // store.state.user.isLogin && store.getters['awsSdk/product'] && store.dispatch('awsSdk/getAwsSdk', 'product')
//     if (to.path === '/hqsyshome') {
//         if (localStorage.getItem('accessTokenExpiry') && localStorage.getItem('refresh_token') && localStorage.getItem('refreshTokenExpiry') && localStorage.getItem('access_token')) {
//             next()
//         } else {
//             next()
//         }
//     } else {
//         next()
//     }
// })
export default router
